export const customers = {
  refresh: 'customers-refreshed',
  list: 'customers-list-received',
  engineering: 'engineering-data-received',
  'short-list': 'customers-short-list-received',

  'filtered-short-list': 'customers-filtered-short-list-received',
  'get-filtered-and-paginated': 'customers-filtered-short-list-received',
  search: 'customers-filtered-short-list-received',

  'search-by-unique-code': 'customers-received',
  'import-updates': 'customer-updates-received',

  get: 'customer-data-received',
  post: 'customer-created',
  save: 'group-of-customers-saved',
  update: 'customers-updated',
  put: 'customer-updated',
  'patch-group': 'group-of-customer-services-updated',
  pagination: 'page-of-customers-received',

  'delete-group': 'customers-deleted',

  services: 'customer-services-received',
  buildings: 'buildings-by-address-list-received',

  'cancelation-date': 'customer-service-cancelation-date-updated',
  'suspension-date': 'customer-service-suspension-date-updated',
  'resuming-date': 'customer-service-resuming-date-updated',

  cancel: 'customer-service-canceled',
  suspend: 'customer-service-suspended',
  resume: 'customer-service-resumed',

  excel: 'customers-for-excel-received',

  'hard-refresh': 'customers-refreshed'
}
